module.exports = __webpack_public_path__ + "img/student-guide-2022.39a24916.jpg";